<div class="mos-u-spacer--margin-bottom-md">
  <atlas-card fullWidth="true" elevation="raised">
    <atlas-card-content class="dsp-mobile-card-content">
      <div class="dsp-mobile-card-header dsp-mobile-card-column mos-u-divider--bottom-md">
        <strong>{{ file.date }}</strong>
        <strong class="mos-u-text-overflow--auto dsp-mobile-card-title">{{ file.title }}</strong>
      </div>
      <div *ngIf="(file.type === 'product-documents') && (file.multiFund)" class="mos-c-accordion--raised"
        (click)="$event.stopPropagation()">
        <atlas-accordion><atlas-accordion-item #accordionRef [arrowIconRight]="false">

            <atlas-accordion-heading>
              <div class="row product_doc_fund_name">
                <div class="columns shrink mos-o-body-2">{{ file.fundLength }} Funds</div>
              </div>
            </atlas-accordion-heading>
            <atlas-accordion-content>
              <div class="row ">
                <div class="columns">
                  <span class="shrink mos-o-body-2" [innerHTML]="file.fund">
                  </span>
                </div>
              </div>
            </atlas-accordion-content>


            <atlas-accordion-expand>
              <div>
                <atlas-icon-button collection="arrows-solid"
                  [icon]="accordionRef.expanded ? 'chevron-up' : 'chevron-down'"></atlas-icon-button>
              </div>
            </atlas-accordion-expand>
          </atlas-accordion-item>
        </atlas-accordion>
      </div>
      <span *ngIf="(file.type !== 'product-documents') ||  (!file.multiFund)" class="shrink mos-o-body-2">
        {{ file.fund }}
      </span>
    </atlas-card-content>
  </atlas-card>
</div>